import { createFileRoute } from '@tanstack/react-router';
import { IndividualContractPage } from '@/pages/contract/individual-contract/individual-contract-page.tsx';

export const Route = createFileRoute('/_auth/einzelvertrag/')({
  component: RouteComponent,
  staticData: { title: 'Einzelvertrag' },
});

function RouteComponent() {
  return <IndividualContractPage />;
}
